import { render } from "./HeroiconsSolidFolderRemove.vue?vue&type=template&id=7d7a6ce1"
const script = {}

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidFolderRemove.vue"]])

export default __exports__